import { jsx as _jsx } from "react/jsx-runtime";
import { Paper, Typography } from '@mui/material';
export const StagingBanner = () => (_jsx(Paper, { sx: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: (theme) => theme.palette.warning.dark,
        color: '#fff',
        position: 'fixed',
        top: 0,
        zIndex: 2000,
        left: 0,
        height: 22,
        px: 1,
        borderRadius: 1,
    }, children: _jsx(Typography, { variant: 'caption', sx: {
            fontWeight: 'bold',
            color: '#fff',
            fontSize: '0.7rem',
        }, children: "Staging!" }) }));
